import { State } from 'src/common/types/reducer';
import { DepartmentResume } from 'src/modules/configurations';

export const INITIAL_OPERATION_STATE: State<Array<DepartmentResume>> = {
    data: [],
    hasError: false,
    isLoading: true,
};
